import { EMAIL_LABEL, PASSWORD_LABEL } from '@App/forms/common/generic-form-field-props'
import FormFieldProps from '@App/forms/v2/common/form-field'
import { FormFieldTypes } from '@App/enum/form-field-types'

export const STANDARD_USERNAME: FormFieldProps = {
    name: 'username',
    label: EMAIL_LABEL,
    type: FormFieldTypes.TEXT,
    assistiveTextVisibility: { errors: false, assistive: false },
}

export const STANDARD_PASSWORD: FormFieldProps = {
    name: 'password',
    label: PASSWORD_LABEL,
    type: FormFieldTypes.TEXT,
    assistiveTextVisibility: { errors: false, assistive: false },
    inputType: 'password',
}
